const Login = () => import(/* webpackChunkName: "Login" */ "@/views/Login")

const sessionRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      isPublic: true
    }
  }
];

export default sessionRoutes;